// src/constants/storageKeys.js
export const STORAGE_KEYS = {
    // Auth related
    AUTH_TOKEN: 'authToken',
    USER_DATA: 'userData',
    
    // Dashboard related
    DASHBOARD_LAYOUT: 'dashboard_layout',
    DASHBOARD_FULL_LAYOUT: 'dashboard_full_layout',
    DASHBOARD_VISIBILITY: 'dashboard_visibility',
    DASHBOARD_SIDEBAR_VISIBILITY: 'dashboard_sidebar_visibility',
    DASHBOARD_CARD_PREFERENCES: 'dashboard_card_preferences',
    
    // Sidebar related
    SIDEBAR_PREFERENCES: 'sidebarPreferences',
    UNIT_SELECTIONS: 'unit_selections',
    
    // Other app settings
    THEME: 'theme',
    LANGUAGE: 'language',
  };